import { linkedPackage } from 'lincd/utils/Package';
export const { linkedComponent, linkedShape, linkedUtil, linkedOntology, registerPackageExport, packageExports, packageName, } = linkedPackage('lincd-capacitor');
//# sourceMappingURL=package.js.map